<template>
  <!-- visit-finish -->
  <div class="vf">
    <div class="vf-panel">
      <img src="@/assets/img/icon-success.png" alt="提交成功">
      <div class="vf-info">提交成功，等待审核</div>
      <div class="vf-txt" >
          您的信息提交成功，等待组委会审核，审核结果将以短信的方式通知您，请耐心等待！
      </div>
      <div class="vf-award-btn" @click="link('home')">返回首页</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import gql from 'graphql-tag'

export default {
  // 注册成功页面
  data() {
    return {
      CardId: "",
      VisitorRegRemind:null, // 自定义注册完成描述
    };
  },
  computed: {
    ...mapGetters({
      userInfo:'getUserInfo',
      exhibitionId:'getExhibitionId',
      exhibitionInfo:'getExhibitionInfo',
      exhibitionConfig:"getExhibitionConfig"
    }),
  },
  async created() {
    await this.$Myapollo.getUserInfo(this);
  },
  methods: {
    ...mapActions({
      LinkFooter: "linkTo/LinkFooter",
      LinkToMyPapers:"linkTo/LinkToMyPapers"
    }),
    link(type){
      switch(type){
        case 'home' :
          var opt = {
            url: `/home/${this.exhibitionId}`,
          };
          this.LinkFooter(opt);
          break;
        case 'card' :
          this.LinkToMyPapers();
          break;
        case 'head' :
          this.$store.commit('setHeadTab','exinfo')
          var req = {
            url: `/news/${this.exhibitionId}`,
          };
          this.LinkFooter(req);
          break;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.vf {
  &-panel {
    text-align: center;
    background: #fff;
    padding: 36px 0 30px;
    // margin-bottom: 12px;
    // border-bottom: 10px solid #f5f5f5;
    img {
      width: 75px;
      display: inline-block;
      margin-bottom: 15px;
    }
  }
  &-info {
    font-size: 20px;
    line-height: 24px;
    color: #0290fe;
    margin-bottom: 17px;
  }
  &-txt {
    font-size: 14px;
    line-height: 24px;
    color: #999;
    margin-bottom: 25px;
    width: 76%;
    margin: 0 auto;
  }
  &-btn {
    width: 180px;
    line-height: 35px;
    background-color: #0290fe;
    border-radius: 3px;
    color: #fff;
    margin: 0 auto 12px;
    font-size: 15px;
  }
  &-award {
    padding: 10px 15px;
    background: #fff;
    display: flex;
    align-items: center;
    img {
      width: 75px;
      height: 50px;
    }
    &-txt {
      padding: 0 11px;
      font-size: 15px;
      color: #333;
      flex: 1;
    }
    &-btn {
      width: 3.5rem;
      height: .92rem;
      text-align: center;
      line-height: .92rem;
      border-radius: 3px;
      border: solid 1px #1890ff;
      color: #1890ff;
      font-size: .36rem;
      margin: .6rem auto 0;
    }
  }
}
</style>